import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function irrbba(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@irrbba/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@irrbba/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@irrbba/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@irrbba/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@irrbba/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@irrbba/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}